export const CLOSE_OVERLAY = 'CLOSE_OVERLAY'
export const MOUNT_OVERLAY = 'MOUNT_OVERLAY'
export const OPEN_OVERLAY = 'OPEN_OVERLAY'
export const PREPARE_CLOSE_OVERLAY = 'PREPARE_CLOSE_OVERLAY'
export const UNMOUNT_OVERLAY = 'UNMOUNT_OVERLAY'
export const UPDATE_OVERLAY = 'UPDATE_OVERLAY'
